import axios from "axios";
import { getApiBaseUrl } from "./apiBaseUrl";
import { getStoredDepartmentView } from "../components/DepartmentSwitcher";

const api = axios.create({
  baseURL: getApiBaseUrl(),
});

const LEGACY_AUTH_KEYS = ["role", "user", "userStatus", "needsOnboarding"];

function clearAuthStorage() {
  localStorage.removeItem("token");
  LEGACY_AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
}

api.interceptors.request.use(
  (req) => {
    const token = localStorage.getItem("token");
    if (token) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    if (!req.skipDepartmentView) {
      const departmentView = getStoredDepartmentView();
      if (departmentView) {
        req.params = { ...(req.params || {}), departmentView };
      }
    }
    return req;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || "";

    const isAuthEndpoint =
      requestUrl.includes("/auth/login") ||
      requestUrl.includes("/auth/register") ||
      requestUrl.includes("/auth/request-otp") ||
      requestUrl.includes("/auth/verify-otp") ||
      requestUrl.includes("/auth/microsoft");

    if (error.response?.status === 401 && !isAuthEndpoint) {
      clearAuthStorage();
      window.location.href = "/";
      return Promise.reject(error);
    }

    if (error.response?.status === 403 && error.response?.data?.code === "ONBOARDING_REQUIRED") {
      window.dispatchEvent(new Event("auth:onboarding-required"));
      if (window.location.pathname !== "/onboarding") {
        window.location.href = "/onboarding";
      }
      return Promise.reject(error);
    }

    // Backstop for an account awaiting approval. Without this the page loads
    // but every request fails silently, leaving no way back to the waiting
    // screen — the session says approved while the server disagrees.
    if (error.response?.status === 403 && error.response?.data?.code === "ACCOUNT_NOT_APPROVED") {
      if (window.location.pathname !== "/pending-approval") {
        window.location.href = "/pending-approval";
      }
      return Promise.reject(error);
    }

    const deniedMsg = error.response?.data?.message || "";
    if (
      error.response?.status === 403 &&
      error.response?.data?.code !== "ONBOARDING_REQUIRED" &&
      error.response?.data?.code !== "ACCOUNT_NOT_APPROVED" &&
      /access denied|insufficient role|permission/i.test(deniedMsg)
    ) {
      window.dispatchEvent(new Event("auth:resync"));
    }

    return Promise.reject(error);
  }
);

export default api;
